import { defineComponent as _defineComponent } from 'vue'
import BaseButtonV2 from "@/components-UI/buttons/BaseButtonV2.vue";
import SvgPlus from "@/assets/icons/plus.svg";

interface Props {
    disabled?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AddOfferButton',
  props: {
    disabled: { type: Boolean, default: false }
  },
  emits: ["start-add"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'start-add'): void;
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emit, BaseButtonV2, SvgPlus }
}

})